import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";

import TextField from "@material-ui/core/TextField";

import Button from "../../components/button";
import ICCheckbox from "../../components/form/checkbox";

const SendNotificationForm = props => {

  const formik = useFormik({
    initialValues: {
      selectedUser: "",
      message: "",
      selectState: "",
      isEmail: false,
      isSMS: false,
      isPushNotification: false
    },
    validationSchema: Yup.object({
      selectedUser: Yup.string().required("Please select User"),
      selectState: Yup.string().when("selectedUser", {
        is: "Patient",
        then: Yup.string().required("Please select State")
      }),
      message: Yup.string().required("Please enter message")
    }),
    onSubmit: values => {
      var formData = new FormData();
      if (values.selectedUser === "Patient") {
        formData.append("selectedState", values.selectState);
      }
      if (values.selectedUser === "ALL USERS") {
        formData.append("message", values.message);
        formData.append("fromWhere", "profile");
      } else {
        formData.append("user", values.selectedUser);
        formData.append("message", values.message);
        formData.append("fromWhere", "profile");
      }

      formData.append("isEmail", values.isEmail);
      formData.append("isSMS", values.isSMS);
      formData.append("isPushNotification", values.isPushNotification);

      props.onFormSubmit(formData, values.selectedUser);
    }
  });

  return (
    <form className="d-flex flex-column" onSubmit={formik.handleSubmit}>
      <p>
        Select User <span className="error">*</span>
      </p>
      <TextField
        name="selectedUser"
        className="w-100"
        select
        value={formik.values.selectedUser}
        SelectProps={{
          native: true
        }}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched.selectedUser && formik.errors.selectedUser
            ? true
            : false
        }
        helperText={
          formik.touched.selectedUser && formik.errors.selectedUser
            ? formik.errors.selectedUser
            : ""
        }
      >
        <option>Select User</option>
        <option value="Doctor">ALL DOCTORS</option>
        {/* <option value="NURSE">ALL NURSES</option> */}
        <option value="Patient">ALL PATIENTS</option>
        <option value="ALL USERS">ALL USERS</option>
      </TextField>
      <br />
      {formik.values.selectedUser === "Patient" && (
        <TextField
          name="selectState"
          className="w-100"
          select
          value={formik.values.selectState}
          SelectProps={{
            native: true
          }}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.selectState && formik.errors.selectState
              ? true
              : false
          }
          helperText={
            formik.touched.selectState && formik.errors.selectState
              ? formik.errors.selectState
              : ""
          }
        >
          <option>Select State</option>
          <option value="all">All</option>
          <option value="ACT">ACT</option>
          <option value="NSW">NSW</option>
          <option value="NT">NT</option>
          <option value="QLD">QLD</option>
          <option value="SA">SA</option>
          <option value="TAS">TAS</option>
          <option value="VIC">VIC</option>
          <option value="WA">WA</option>
        </TextField>
      )}

      <p className="mb-0">
        Select Message types <span className="error">*</span>
      </p>

      <div className="row ml-1">
        <ICCheckbox
          className="m-2  ic-checkbox" //todo check why ic-checkbox class isn't being appled
          label="Email"
          id="Email"
          name="isEmail"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          checked={formik.values.isEmail}
          value={formik.values.isEmail}
        />

        <ICCheckbox
          className="m-2 ic-checkbox"
          label="SMS"
          id="SMS"
          name="isSMS"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          checked={formik.values.isSMS}
          value={formik.values.isSMS}
        />

        <ICCheckbox
          className="m-2 ic-checkbox"
          label="Push Notification"
          id="PushNotification"
          name="isPushNotification"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          checked={formik.values.isPushNotification}
          value={formik.values.isPushNotification}
        />
      </div>

      <p className="font-thicker">
        Message <span className="error">*</span>
      </p>
      <TextField
        name="message"
        className="w-100"
        rows="5"
        multiline
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.message}
        error={formik.touched.message && formik.errors.message ? true : false}
        helperText={
          formik.touched.message && formik.errors.message
            ? formik.errors.message
            : ""
        }
      />
      <br />
      <p className="mb-0 d-flex justify-content-center">
        <Button disabled={formik.isSubmitting} title="Submit" type="submit" />
      </p>
    </form>
  );
};

export default SendNotificationForm;

SendNotificationForm.defaultProps = {
  onFormSubmit: () => {
  }
};

SendNotificationForm.propTypes = {
  onFormSubmit: PropTypes.func
};
